<!-- 资鲸课堂服务协议 -->
<template>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="serviceAgreementDialog" width="800px" title="资鲸课堂服务协议" :visible.sync="dialogVisible">
        <div class="agreementContent">
            <p class="blod">【首部及导言】</p>
            <p>欢迎您使用资鲸课堂服务（以下简称：“本服务”）！</p>
            <p>为使用本服务，您应当阅读并遵守《资鲸课堂服务协议》（以下称“本协议”）、《快捷支付服务协议》、 《微信支付用户服务协议》、《微信电子商务服务协议》、《资鲸课堂隐私政策》  等相关协议及业务规则。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除资鲸责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款（如第七条相关约定），以及开通或使用某项服务的单独协议或规则。限制或免除责任条款或者其他涉及您重大权益的条款，可能以加粗、加下划线等形式提示您注意。</p>
            <p>除非您已阅读、完全理解并接受本协议所有条款，否则您无权使用本服务。您点击“同意”或“下一步”，或您使用资鲸服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与资鲸之间产生法律效力，成为对双方均具有约束力的法律文件。</p>
            <p>如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读并判断是否同意本协议，并特别注意未成年人使用条款。</p>
            <p>如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。</p>
            <p class="blod">一、【协议范围】</p>
            <p>1.1本协议是您（以下也称“用户”）、深圳市资鲸科技有限公司（以下简称“资鲸”）、课程开发者等之间关于您使用本服务所涉相关事项的法律协议。</p>
            <p>1.2资鲸有权对本协议进行调整或补充，并在资鲸课堂平台（<a href="https://ke.capwhale.com/" target="_blank"></a>）公告。若用户继续使用资鲸课堂服务的，则视为接受该等调整或补充，如果您不接受调整或补充，应立即停止使用该服务。</p>
            <p class="blod">二、【术语定义】</p>
            <p>如无特别说明，下列术语在本协议中的含义为：</p>
            <p>
                2.1.
                <span class="spanblod">课程发布者：</span>
                指经有效注册、申请后，将其享有相应权利的各种课程接入资鲸课堂，并向用户提供各种免费或收费类的在线直播、录播服务，以实现与用户进行在线交流与学习功能的个人、法人或其他组织，因前述主体的不同，课程发布者在对外展现上也称“机构”或“老师”。
            </p>
            <p>
                2.2.
                <span class="spanblod">课程：</span>
                指由课程发布者开发，或课程发布者经权利人授权，通过资鲸课堂向相关用户提供各种免费或收费类的在线直播、录播形式的交流与学习服务，包括但不限于网络营销类、语言类、公务员考试类、小学/初中/高中教育辅导类（非学历教育）等现存的各种培训服务及今后可能出现的各种培训服务。课程是否收费、课程收费的数额、课程收费方式、课程的收费期限等均由课程发布者自行决定。
            </p>
            <p>
                2.3
                <span class="spanblod">内容上传者：</span>
                指经有效注册、申请后，将其享有相应权利的各种内容接入资鲸课堂，并向用户提供免费的文字、图片、视频、音频、链接等内容，以实现与用户进行交流与学习功能的个人、法人或其他组织，因前述主体的不同，内容发布者在对外展现上也称"创作者”。
            </p>
            <p>
                2.4
                <span class="spanblod">内容：</span>
                指由内容上传者通过资鲸课堂向相关用户提供的，其没有权利瑕疵（包括自身是权利人或者得到权利人充分授权）的各种资讯、资料、文字、软件、音乐、音频、照片、图形、视频、信息、链接或其他资料。
            </p>
            <p>
                2.5
                <span class="spanblod">资鲸课堂：</span>
                资鲸公司所有和经营的有关教育、学习等数字内容聚合、管理和分发的平台产品，旨在为课程发布者、内容上传者及用户提供知识内容的生成、传播和学习等平台服务。
            </p>
            <p>资鲸、课程发布者、内容上传者、用户均同意和理解：</p>
            <p>（1）资鲸课堂是一个中立的平台服务提供者，仅向课程发布者与内容上传者提供信息存储空间、链接等中立的网络服务或相关中立的技术支持服务，以供课程发布者与内容上传者在中立的平台上自主发布、运营、推广其课程与内容等；</p>
            <p>（2）课程发布者的课程由课程发布者自主开发或提供、独立运营并独立承担全部责任。资鲸不会、也不可能参与课程发布者课程的研发、运营等任何活动，资鲸也不会对课程发布者的课程进行任何的修改、编辑或整理等。内容上传者的内容由内容上传者开发或提供、独立运营并独立承担全部责任。资鲸不会、也不可能参与内容上传者内容的研发、运营等任何活动。内容上传对在资鲸课堂上传或发布的内容享有合法的著作权或相应授权，资鲸课堂有权展示、散布及推广前述内容。</p>
            <p>
                （3）因课程发布者课程产生的任何纠纷、责任等，以及课程发布者违反相关法律法规或本协议约定引发的任何后果，均由课程发布者独立承担责任、赔偿损失，与资鲸无关。如侵害到用户、资鲸或他人权益的，课程发布者须自行承担全部责任和赔偿一切损失。因内容上传者内容产生的任何纠纷、责任等，以及内容上传者违反相关法律法规或本协议约定引发的任何后果，均由内容上传者独立承担责任、赔偿损失，与资鲸无关。如侵害到用户、资鲸或他人权益的，内容上传者须自行承担全部责任和赔偿一切损失。
                <span class="spanblod">对于第三方因内容上传者上传的内容向资鲸课堂主张权利的，资鲸课堂有权在不事先通知内容上传者的情况下直接采取删除、屏蔽、断开链接等必要措施，以及停止侵权内容的激励收益发放。</span>
            </p>
            <p class="blod">三、【关于本服务】</p>
            <p>
                3.1.
                <span class="spanblod">【本服务内容】</span>
            </p>
            <p>本服务是指资鲸科技公司所有和经营的数字内容聚合、管理和分发的平台服务。</p>
            <p>
                3.2.
                <span class="spanblod">【帐号使用规范】</span>
            </p>
            <p>用户可以通过QQ号码、微信号码、手机号码等方式登陆本服务帐号，登陆方式以资鲸提供的软件版本为准。资鲸有权根据服务需要对帐号注册和登录的方式进行变更，关于使用帐号的具体规则，请用户遵守《QQ号码规则》、《资鲸微信软件许可及服务协议》等相关帐号使用协议以及资鲸为此发布的专项规则。当用户使用本服务时，用户应选择与用户的终端、系统等相匹配的版本，否则，用户可能无法正常使用本服务。注册完成后，请用户妥善保存有关帐号和密码，并对该帐号进行的所有活动和行为负责。如因用户自身过错（包括但不限于转让帐号、与他人共用、自己泄露等）或用户所用计算机或其他终端产品感染病毒或木马，而导致帐号密码泄漏、遗失或其他损失后果将由用户独自承担。</p>
            <p>用户需理解并承诺，用户所设置的帐号不得违反国家法律法规相关规定，用户的帐号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设帐号，不得恶意注册帐号（包括但不限于频繁注册、批量注册帐号等行为）。用户在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。资鲸有权对用户所提交的注册信息进行审核。</p>
            <p>用户在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规（本协议中的“法律法规”指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等，下同。）有特殊规定的，用户需要填写真实的身份信息（包括但不限于手机号等信息）。若用户填写的信息不完整或不真实，则可能无法使用本服务或在使用过程中受到限制。</p>
            <p class="blod">四、【服务的使用】</p>
            <p>用户通过本服务来使用课程发布者提供的课程时，用户应当注意以下几点：</p>
            <p>4.1.用户通过本服务使用的课程均由课程发布者单独提供，用户在查询、报名、购买、使用课程或支付费用等之前，应该谨慎判断课程发布者发布的课程相关信息（包括但不限于课程的内容、开课的时间、开课的期限等）的准确性、真实性、合法性，并自行判断课程发布者的履约能力，资鲸对课程发布者提供的课程无法做任何保证，也不承担任何责任。因查询、报名、购买、使用课程或支付费用等产生的任何纠纷，用户应当与课程发布者协商或诉讼解决，并独立承担相应的风险或责任，与资鲸、财付通公司无关。</p>
            <p>4.2.用户向课程发布者购买收费课程服务时，可选择财付通公司提供的相关支付方式【包括但不限于微信支付、银行卡支付等方式，具体以实际提供的方式为准】或者其他非财付通公司提供的方式完成支付（注：为了更好地保护您的合法权益，资鲸建议您尽可能选择财付通公司提供的支付方式来完成支付）。</p>
            <p>如用户选择使用财付通公司提供的微信支付、银行卡支付等方式完成支付的，用户应妥善保管相关支付账号及支付密码，任何经由用户支付账号发出的操作指令，均视为用户本人的行为，用户应自行对经由其相关支付账号所进行的一切操作行为负责。如一旦发现支付账号被冒用、盗用、密码遗失或其他未经授权的使用，用户应立即按照QQ钱包、微信支付、银行卡支付等相关协议及规则的相关规定向财付通公司办理挂失手续。</p>
            <p>4.3.用户向课程发布者成功报名课程（收费课程的报名成功指用户报名后向课程发布者支付成功相应费用并经课程发布者确认报名成功的；免费课程的报名成功指用户报名后并经课程发布者确认报名成功的。）后，资鲸课堂会根据课程发布者的设置及课程收费或免费的情况，自动将您分配或引导用户自行申请、加入到课程发布者设定的该课程所对应的QQ群中，同时用户了解并同意以下事项：</p>
            <p>（1）用户加入课程相关的QQ群后，应当同时遵守《QQ群服务协议》及其他相关协议。用户在课程未履行完毕前，如用户自行从QQ群中退出的，用户应当自行承担相应的后果，包括自行联系课程开发者再次加入QQ群、未及时收听在线直播的课程等。</p>
            <p>（2）用户成功报名课程后，应当在课程发布者规定的课程时间及期限内及时接受由课程发布者提供的相关课程服务，如因非资鲸课堂或课程发布者原因（包括但不限于用户设备故障、网络阻塞、网络断开、忘记课程时间等）导致未能完整接受或未能接受课程发布者提供的相关课程服务时，用户应当自行承担相应责任并默认用户已学习相关课程服务且用户无权要求退还任何费用。</p>
            <p>4.4.用户向课程发布者支付课程费用后，如需索要发票等支付凭证或者服务单据的，用户应当联系课程发布者解决，与资鲸无关。</p>
            <p>4.5.本服务仅供用户成功报名课程时选择的QQ号码或微信号码（QQ号码与微信号码相互独立）使用。用户如需更换QQ号码或微信号码或增加QQ号码或微信号码来接受课程服务时，如报名成功的课程为收费课程时，用户需另行支付相应的费用。</p>
            <p>4.6用户使用本服务应遵守本协议首部所述的相关协议和规则，其中业务规则是指包括但不限于在本协议、本服务过程中勾选或提供链接提示的协议、或服务页面中告知用户的关于本服务具体服务说明、服务标准、用户行为规范和课堂管理制度等内容。如您不同意相关内容，您可以停止使用本服务。</p>
            <p>4.7.关于退费</p>
            <p>4.7.1.用户向课程发布者支付课程费用后，如课程发布者发布的课程不存在违反法律法规规定及，亦不存在按资鲸课堂相关规定可以退费的情况下，则用户均不得申请退费。</p>
            <p>4.7.2 用户理解并同意，课程发布者通过资鲸课堂平台发布的收费课程将采用整体购买的方式，即用户只需购买一次，就可以学习该课程所有已发布或即将发布的课时。已购买的收费课程，用户可以自己重复学习，无需再次付费。但请用户注意，在符合相关法律、法规规定的情况下，用户同意按照如下规则退费：</p>
            <p>4.7.2.1如果用户购买的是直播或录播课程，由于用户可以观看已经开课课程的回放内容，因此，可以回放的课程视为用户已经学习的课程而不予退费，即，用户可以要求退费的比例为尚未直播或录播的课程除以课程发布者发布的所有课程。</p>
            <p>4.7.2.2用户向课程发布者支付课程费用后，符合资鲸课堂相关退费规定的，用户可以申请退费。</p>
            <p>（资鲸课堂退费政策：客服电话075586393160）</p>
            <p>4.7.3.若用户与课程发布者之间就款项支付、退款等任何事项，由用户与课程发布者自行协商解决，用户无权向资鲸、财付通公司主张任何权利或要求资鲸、财付通公司承担任何责任。</p>
            <p>4.8.如果用户（学员）认为当天课程质量不合格，应该在当天相应课程完成后两天内提出异议并提供相应证据，逾期提出异议视为课程合格，用户（学员）不得要求退款。用户（学员）的上课课程数量以学员购买相应课程时课程发布者发布的课程数量和内容为准。</p>
            <p>4.9用户知悉并同意，用户无权对已购买的课程进行出售、转让、许可或其他方式使除用户自己以外的第三方（包括但不限于自然人、法人或其他组织）使用其已购买的课程。若用户违反本条规定，则资鲸有权视情况采取如下措施：</p>
            <p>（1）取消用户继续使用该课程的权利；</p>
            <p>（2）限制/冻结用户的帐号；</p>
            <p>（3）要求用户退还其通过出售、转让、许可等其他方式取得的收益；</p>
            <p>（4）其他资鲸可以采取的救济措施。</p>
            <p>4.10、用户了解并同意，课程发布者可能会基于自身原因（包括但不限于：更新课程内容、改进课程安排）不定期的对收费课程进行更新而无需经过您的事先同意。</p>
            <p class="blod">五、【用户行为规范】</p>
            <p>5.1信息内容规范</p>
            <p>5.1.1 本条所述信息内容是指用户使用本服务过程中所制作、复制、发布、传播的任何内容，包括但不限于使用本服务中发布的文字、语音、图片、视频、表情等信息、相关链接页面。</p>
            <p>5.1.2 您理解并同意，资鲸课堂致力于为用户提供文明健康、规范有序的网络环境，您不得在本服务中复制、发布、传播如下干扰资鲸课堂正常运营，以及侵犯其他用户、课堂老师或第三方合法权益的内容，包括但不限于：</p>
            <p>5.1.2.1发布、传送、传播违反国家法律法规禁止的内容：</p>
            <p>（1）违反宪法确定的基本原则的；</p>
            <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
            <p>（3）损害国家荣誉和利益的；</p>
            <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
            <p>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
            <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
            <p>（10）以非法民间组织名义活动的；</p>
            <p>（11）不符合社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性要求的；</p>
            <p>（12）含有法律、行政法规禁止的其他内容的。</p>
            <p>5.1.2.2 发布、传送、传播侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
            <p>5.1.2.3 涉及他人隐私、个人信息或资料的；</p>
            <p>5.1.2.4 发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；</p>
            <p>5.1.2.5 其他违反法律法规、政策及公序良俗、社会公德或干扰资鲸课堂正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
            <p class="blod">六、【知产产权】</p>
            <p>6.1资鲸课堂相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于资鲸公司所有。资鲸公司提供本服务时所依托的软件的著作权、专利权及其他知识产权均归资鲸公司所有。未经资鲸公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载“资鲸课堂”软件及相关服务中的内容）。</p>
            <p>6.2资鲸课堂平台上课程发布者提供的所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、以及有偿内容或服务均由课程发布者或其他权利人依法拥有其知识产权，包括但不限于著作权、商标权、专利权等。非经资鲸、课程发布者等对应权利人的书面同意用户不得对上述内容进行擅自使用、修改、复制、传播、改变、散布、发行或发表等行为，如有违反，用户同意承担由此给资鲸、课程发布者或其他权利人造成的一切损失。</p>
            <p>6.3资鲸课堂平台上内容上传者提供的所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、以及相关内容服务均由内容上传者或其他权利人依法拥有其知识产权，包括但不限于著作权、商标权、专利权等。非经资鲸、内容上传者等对应权利人的书面同意用户不得对上述内容进行擅自使用、修改、复制、传播、改变、散布、发行或发表等行为，如有违反，用户同意承担由此给资鲸、内容上传者或其他权利人造成的一切损失。</p>
            <p class="blod">6.4 为提高您内容曝光量及发布效率，您同意您在资鲸课堂的账号所发布的全部内容均授权资鲸课堂以您的账号自动同步发布至资鲸课堂运营的全部产品，包括但不限于客户端软件及网站。您在资鲸课堂发布、修改、删除内容的操作，均会同步到上述产品。您在资鲸课堂上传或发布的内容，您保证对其享有合法的著作权或相应授权，资鲸课堂有权展示、散布及推广前述内容。</p>
            <p class="blod">七、【法律责任】</p>
            <p>7.1.用户在使用本服务时，应当清楚并同意按以下约定承担相应责任：</p>
            <p>7.1.1.资鲸在本服务中的责任</p>
            <p>用户因使用本服务查询、报名、购买、使用课程发布者提供的课程发生纠纷时，由于相应课程均由课程发布者单独提供，资鲸不会也无法参与其中，因此，用户应当与课程发布者协商、诉讼解决，并独立承担相应的风险或责任，与资鲸无关。但，由于资鲸过错造成的，资鲸会依法承担相应责任。</p>
            <p>7.1.2.财付通公司在本服务中的责任</p>
            <p>本服务中的财付通公司提供的相关支付功能也仅是财付通公司向用户提供的一个中立的支付服务，用户因使用支付功能产生的纠纷，用户应与财付通公司协商解决并参照财付通的相关协议和规则，与资鲸无关。但，用户查询、报名、购买、使用课程产生的任何纠纷，用户应当按照本协议的约定与课程发布者通过协商、诉讼解决，并独立承担相应的风险或责任的，与财付通公司无关。</p>
            <p>7.1.3.课程发布者在本服务中的责任</p>
            <p>用户查询、报名、购买、使用的课程，均由课程发布者单独提供并由课程发布者独立承担责任，用户因查询、报名、购买、使用的课程不符合双方约定或法律法规的规定而与课程发布者发生纠纷的，用户应当与课程发布者协商、诉讼解决，课程发布者应该依法承担相应的责任，与资鲸或财付通公司无关。</p>
            <p>7.1.4.内容上传者在本服务中的责任</p>
            <p>用户查询、观看的内容，均由内容上传者单独提供并由内容上传者独立承担责任，用户因观看内容不符合双方约定或法律法规的规定而与内容上传者发生纠纷的，用户应当与内容上传者协商、诉讼解决，内容上传者应该依法承担相应的责任，与资鲸或财付通公司无关。</p>
            <p>7.2.用户同意并理解，本服务的使用需以用户合法享有QQ号码或微信号码和财付通支付账户、微信支付账户、QQ钱包账户（包括但不限于财付通账户绑定的银行卡号）的合法使用权为基础，如用户因违反资鲸或财付通公司相关约定或相关法律、政策的规定，被资鲸或财付通公司做出相应处罚的，可能会影响用户在本服务中的使用，用户应当自行承担相应后果，造成资鲸、财付通公司或他人损失的，用户应承担全部责任。</p>
            <p>7.3.用户同意并理解，课程发布者拥有课程版权，私自录像或未经版权所有者同意擅自传播属于侵权行为；发生版权纠纷的，课程发布者应当与侵权者协商、诉讼解决，侵权者应该依法承担相应的责任；平台有权协助课程发布者终止侵权者使用课程并不退还缴纳的费用。</p>
            <p>
                7.4.用户同意并理解，内容上传者拥有内容版权，私自录像或未经版权所有者同意擅自传播属于侵权行为；发生版权纠纷的，内容上传者应当与侵权者协商、诉讼解决，侵权者应该依法承担相应的责任；
                <span class="spanblod">对于第三方因内容上传者上传的内容向资鲸课堂主张权利的，资鲸课堂有权在不事先通知内容上传者的情况下直接采取删除、屏蔽、断开链接等必要措施。</span>
            </p>
            <p>7.5用户同意并理解，用户应遵守本协议规定的行为规范和服务页面中告知的其他行为规范，否则，资鲸课堂将视具体违反情况和影响有权限制您使用某些具体服务，限制/冻结您的资鲸课堂账户权限，并保留追究您法律责任的权益。</p>
            <p>7.6 资鲸课堂对于任何包含、经由或连接、下载或从任何与有关本网络服务所获得的任何内容、信息或广告，不声明或保证其正确性或可靠性；并且对于用户经本服务上的广告、展示而购买、取得的任何产品、信息或资料，资鲸课堂不负保证责任。用户自行负担使用本服务的风险。</p>
            <p>7.7 内容上传者制作、发布、传播的内容需遵守《网络音视频信息服务管理规定》等法律法规规定以及资鲸课堂公布的创作规则，不得利用基于深度学习、虚拟现实等的新技术新应用制作、发布、传播虚假新闻信息等法律法规禁止的信息内容。您在发布或传播利用基于深度学习、虚拟现实等的新技术新应用制作的非真实音视频信息时，应当以显著方式予以标识，否则资鲸课堂有权对相关内容和账户采取包括但不限于增加标识、限制、封禁等措施，并有权对侵权行为进行追索。</p>
            <p class="blod">八、【投诉】</p>
            <p>8.1如您被他人投诉或您投诉他人，资鲸有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。</p>
            <p>8.2.您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。</p>
            <p class="blod">九、【其他】</p>
            <p>9.1.本协议签订地为中华人民共和国广东省深圳市南山区。</p>
            <p>9.2.本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
            <p>9.3.若您和资鲸、财付通公司、课程发布者之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
            <p>9.4.本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
            <p>9.5.本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
            <p>9.6.若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。（完）</p>
            <p class="blod right">资鲸科技</p>
        </div>
        <div class="btn">
            <el-button @click="haveKnown" type="primary" :disabled="second !== 0">{{second > 0 ? `已知悉（${second}s）` : '已知悉'}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {setCookie} from '@/common/js/tools'
export default {
    data() {
        return {
            dialogVisible: false,
            second: 6
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.second = 6
            this.dialogVisible = true
            let timer = setInterval(() => {
                if (this.second > 0) {
                    this.second--
                } else {
                    clearInterval(timer)
                }
            }, 1000)
        },
        haveKnown() {
            setCookie('capwhaleOpenCourse', 1, 30)
            this.dialogVisible = false
            this.$emit('getList')
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .serviceAgreementDialog {
        .el-dialog {
            .el-dialog__header {
                text-align: center;
                padding: 20px;
                .el-dialog__title {
                    font-weight: bold;
                    font-size: 18px;
                    letter-spacing: 4px;
                }
            }
        }
        .agreementContent {
            height: 400px;
            overflow-y: scroll;
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                background-color: #c1c1c1;
            }
            .blod {
                font-weight: bold;
            }
            p {
                color: #333;
                font-size: 14px;
                line-height: 24px;
                text-indent: 14px;
                .spanblod {
                    font-weight: bold;
                }
            }
            .right {
                text-align: right;
            }
        }
        .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 0 0;
            .el-button {
                width: 96px;
                height: 32px;
                margin-bottom: 0;
            }
        }
    }
</style>